import { render, staticRenderFns } from "./TraningQuiz.vue?vue&type=template&id=55f18152&"
import script from "./TraningQuiz.vue?vue&type=script&lang=ts&"
export * from "./TraningQuiz.vue?vue&type=script&lang=ts&"
import style0 from "./TraningQuiz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports